import { useCallback } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useAuthStore } from '../store/auth'
import { apiClient } from '../api/client'
import {
  Button,
  Input,
  FormField,
  Card,
} from '../components'

export default function RegisterPage() {
  const navigate = useNavigate()
  const { setUser, setOrganizations, setActiveOrg } = useAuthStore()

  const handleSubmit = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const form = e.currentTarget
    const email = (form.elements.namedItem('email') as HTMLInputElement).value.trim()
    const name = (form.elements.namedItem('name') as HTMLInputElement).value.trim()
    const organization_name = (form.elements.namedItem('organization_name') as HTMLInputElement).value.trim()
    const business_id = (form.elements.namedItem('business_id') as HTMLInputElement).value.trim()

    try {
      const data = await apiClient.post<{
        user: { id: string; email: string; name: string }
        organization?: { id: string; name: string }
      }>('/auth/register', { email, name, organization_name, business_id: business_id || undefined })
      setUser(data.user)
      const orgs = data.organization ? [{ ...data.organization, role: 'owner' }] : []
      setOrganizations(orgs)
      if (orgs.length > 0) setActiveOrg(orgs[0])
      navigate('/dashboard')
    } catch (err) {
      console.error(err)
      alert(err instanceof Error ? err.message : 'Verkkovirhe, yritä uudelleen')
    }
  }, [navigate, setUser, setOrganizations, setActiveOrg])

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full space-y-6">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-indigo-700">📚 Kirstunvartija</h1>
          <p className="mt-2 text-gray-600">Luo tili yhdistyksellesi</p>
        </div>

        <Card padding="lg">
          <h2 className="text-xl font-semibold text-gray-800 mb-6">Rekisteröidy</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <FormField label="Nimi" required>
              <Input
                name="name"
                type="text"
                required
                minLength={2}
                placeholder="Matti Meikäläinen"
              />
            </FormField>

            <FormField label="Sähköposti" required>
              <Input
                name="email"
                type="email"
                required
                placeholder="matti@yhdistys.fi"
              />
            </FormField>

            <FormField label="Yhdistyksen nimi" required>
              <Input
                name="organization_name"
                type="text"
                required
                minLength={2}
                placeholder="Esimerkki ry"
              />
            </FormField>

            <FormField
              label="Y-tunnus"
              helperText="Valinnainen"
            >
              <Input
                name="business_id"
                type="text"
                placeholder="1234567-8"
              />
            </FormField>

            <Button type="submit" size="lg" className="w-full mt-2">
              Luo tili
            </Button>
          </form>
        </Card>

        <p className="text-center text-sm text-gray-500">
          Onko sinulla jo tili?{' '}
          <Link to="/login" className="text-indigo-600 hover:underline">
            Kirjaudu sisään
          </Link>
        </p>
      </div>
    </div>
  )
}
